import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { apiService } from '../../services/api';

export default function SalesDashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [successMessage, setSuccessMessage] = useState(null);
  const [counts, setCounts] = useState({ pending: 0, confirmed: 0, rejected: 0 });
  const [countsLoading, setCountsLoading] = useState(true);
  const displayName = user?.name?.split(' ')[0] || 'User';

  useEffect(() => {
    if (location.state?.message) {
      setSuccessMessage(location.state.message);
      window.history.replaceState({}, '', location.pathname);
    }
  }, [location.state?.message, location.pathname]);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const res = await apiService.orders.getSalesOrderCounts();
        if (!cancelled && res.data) setCounts(res.data);
      } catch {
        if (!cancelled) setCounts({ pending: 0, confirmed: 0, rejected: 0 });
      } finally {
        if (!cancelled) setCountsLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="p-3 sm:p-4 md:p-6 pb-6 sm:pb-8">
      <div className="bg-white rounded-lg shadow-md border-l-4 border-blue-500 p-3 sm:p-5 md:p-6">
        {successMessage && (
          <div className="mb-4 p-3 bg-green-100 border border-green-300 text-green-800 rounded-lg text-sm sm:text-base">
            {successMessage}
          </div>
        )}
        <h1 className="text-xl sm:text-2xl font-bold text-gray-700 mb-1">
          Hello, {displayName}!
        </h1>
        <p className="text-sm sm:text-base text-gray-600 mb-6">Manage your orders.</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 mb-8">
          <button
            type="button"
            onClick={() => navigate('/sales/orders')}
            className="min-h-[44px] sm:min-h-0 bg-orange-200 hover:bg-orange-300 active:bg-orange-400 text-gray-800 rounded-xl py-4 px-4 sm:py-4 sm:px-3 flex flex-col items-center justify-center border border-orange-300 transition-colors touch-manipulation"
          >
            <span className="text-2xl sm:text-2xl mb-2">🕐</span>
            <span className="text-sm sm:text-sm font-semibold">Pending Orders</span>
            {!countsLoading && (
              <span className="text-xs mt-1 text-gray-600 text-center">
                Pending: {counts.pending} · Confirmed: {counts.confirmed} · Rejected: {counts.rejected}
              </span>
            )}
          </button>
          <button
            type="button"
            onClick={() => navigate('/sales/menu')}
            className="min-h-[44px] sm:min-h-0 bg-green-200 hover:bg-green-300 active:bg-green-400 text-gray-800 rounded-xl py-4 px-4 sm:py-4 sm:px-3 flex flex-col items-center justify-center border border-green-300 transition-colors touch-manipulation"
          >
            <span className="text-2xl sm:text-2xl mb-2">➕</span>
            <span className="text-sm sm:text-sm font-semibold">New Order</span>
          </button>
        </div>
      </div>
    </div>
  );
}
